import { useEffect } from 'react';
import { useAnalytics } from '~shared/hooks';
import { EVENTS } from '~shared/lib/analytics/src/constants';

export const useOrderSuccessViewed = () => {
  const { trackPageView } = useAnalytics();

  useEffect(() => {
    trackPageView({
      event: EVENTS.ORDER_SUCCESS_VIEWED,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
